import { KitchenBack, KitchenFront, KitchenShade, KitchenSheen } from './kitchen.art';
import { kitchenRegions } from './kitchen.geometry';
import type { SceneDefinition } from './types';

/** Kitchen countertop: counter top, counter edge and a full-height backsplash. */
export const kitchenScene: SceneDefinition = {
  id: 'kitchen',
  surface: 'countertop',
  regions: kitchenRegions,
  Back: KitchenBack,
  Shade: KitchenShade,
  Sheen: KitchenSheen,
  Front: KitchenFront,
  seams: false,
  photo: null,
};
